import { ENGAGED_2026 } from "@/components/home/Partners";

/**
 * Bandeau défilant en tête de /partenaires.
 * Affiche uniquement les partenaires véritablement engagés (financier / technique) sur 2026.
 * Sert de preuve sociale pour les prospects que nous démarcherons.
 */
export default function EngagedMarquee() {
  // duplicated twice for a seamless infinite loop
  const loop = [...ENGAGED_2026, ...ENGAGED_2026];

  return (
    <section
      className="relative border-y border-fg/15 bg-fg text-bg overflow-hidden"
      data-testid="engaged-marquee"
      aria-label="Partenaires engagés 2026"
    >
      <div className="px-6 md:px-12 py-6 flex items-center gap-6">
        <div className="shrink-0 flex items-center gap-3">
          <span className="w-2.5 h-2.5 rounded-full bg-cinabre animate-pulse" />
          <span className="font-mono text-[10px] tracking-[0.24em] uppercase text-cinabre">§ Engagés 2026</span>
        </div>
        <span className="hidden md:block font-mono text-[10px] tracking-[0.24em] uppercase text-bg/50">
          Financièrement ou techniquement · confirmé
        </span>

        <div className="flex-1 overflow-hidden relative min-w-0">
          {/* Fade edges */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-fg to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-fg to-transparent z-10" />

          <div className="marquee-track flex items-center gap-10 whitespace-nowrap">
            {loop.map((p, i) => (
              <a
                key={`${p.name}-${i}`}
                href={p.url}
                target="_blank"
                rel="noreferrer"
                className="shrink-0 flex items-center gap-4 opacity-90 hover:opacity-100 transition-opacity group"
                title={p.name}
              >
                <span className="w-16 h-10 bg-bg/95 border border-bg/30 flex items-center justify-center overflow-hidden">
                  <img src={p.logo} alt={p.name} className="max-h-8 max-w-[85%] object-contain" loading="lazy" />
                </span>
                <span className="font-serif text-lg text-bg/90 group-hover:text-cinabre transition-colors">{p.name}</span>
                <span className="text-bg/25">·</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
